//product comparison page
import './typescript/errorhandler';
import './typescript/helpers/polyfills';
//scss
import './styles/mpc-shared-basics.scss';
import './styles/comparison-page.scss';
import './styles/comparison-page-header.scss';
import './styles/comparison-page-head-line.scss';
import './styles/comparison-page-controls.scss';
import './styles/comparison-page-row-container.scss';
import './styles/comparison-page-row-field.scss';
import './styles/comparison-page-missing-properties.scss';
import './styles/comparison-page-tooltip.scss';
import './styles/comparison-page-sticky-header.scss';
import './styles/comparison-page.printPage.scss';

import './typescript/PCP/comparison-page-controller';
